﻿import { RioAuditSearchEntityApiModel } from "./RioAuditSearchEntityApiModel";

export class RioAuditContextModel {
    auditModel: RioAuditSearchEntityApiModel;
    setModel: (model: RioAuditSearchEntityApiModel) => void
}